module.exports = __webpack_public_path__ + "img/bgImg@2x.f7b042e4.png";